import React from 'react';
import _ from 'lodash';
import { connect } from 'shalala';
import { Form } from 'react-bootstrap';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import Uuid from '../../support/Uuid';
import { useStore } from '../../store';
import CatalogsCache from '../comprobantes/support/CatalogsCache';
import SuggestionsRefManager from './support/SuggestionsRefManager';
import FaAsyncTypeahead from '../../facturotopia/fa-typahead/FaAsyncTypeahead';

class UnidadDeMedidaSuggestions extends React.Component {
  id = 'unidades-de-medida-suggestions';

  state = {
    isLoading: false,
    options: [],
    query: '',
  };

  cacheManager = null;

  constructor() {
    super();

    this.cacheManager = CatalogsCache.instance('UnidadDeMedida');
  }

  componentWillUnmount() {
    SuggestionsRefManager.remove(this.id);
  }

  handleOnSelect = (item) => {
    const { name } = this.props;

    if (!!item) {
      this.cacheManager.put(name, item);
    }

    this.props.onSelect(item);
  };

  handleSetRef(ref) {
    SuggestionsRefManager.add(ref.name, ref.ref);
  }

  isRequired = (value) => {
    return value === undefined && this.isFieldRequired();
  };

  isFieldRequired() {
    const rules = this.props.rules;

    const result = rules.filter((rule) => rule === 'required');

    let isRequired = false;

    if (!_.isEmpty(result)) {
      isRequired = true;
    }

    return isRequired;
  }

  render() {
    const { name, value, label, suggestions, suggestionsActions } = this.props;

    const values = this.cacheManager.get(name) || [];
    let selectedValue = value ? values.find((item) => item.clave === value) : null;

    if (value && !selectedValue) {
      selectedValue = {
        id: Uuid.v4(),
        clave: value,
      };
    }

    const selectedOption = value ? [selectedValue] : undefined;

    return (
      <>
        {!!label && (
          <Form.Label className={this.isRequired(selectedOption) && 'text-danger font-weight-bold'}>
            {label} {this.isFieldRequired() && <strong> * </strong>}
          </Form.Label>
        )}

        <FaAsyncTypeahead
          id={this.id}
          paginate
          minLength={2}
          placeholder="Buscar clave..."
          paginationText="Mostrar más..."
          searchText="Buscando..."
          labelKey="clave"
          filterBy={(items) => true}
          container={{ state: suggestions, ...suggestionsActions }}
          onSetRef={this.handleSetRef}
          selected={selectedOption || []}
          renderMenuItemChildren={(option) => (
            <div key={option.id}>
              <span>{option.nombre}</span> (<span>{option.clave}</span>)
            </div>
          )}
          onSelect={this.handleOnSelect}
        />
      </>
    );
  }
}

const mapState = (store) => {
  return { suggestions: store.app.catalogos.unidad_de_medida };
};

const mapActions = (actions) => {
  return { suggestionsActions: actions.app.catalogos.unidad_de_medida };
};

export default connect(useStore, mapState, mapActions)(UnidadDeMedidaSuggestions);
